import { Divider, Grid, Paper, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import dayjs from 'dayjs';

import { ITicket } from '@/shared/interfaces/erp/tickets-soporte-clientes';

type InfoTicketProps = {
  ticket: ITicket;
};

type CampoInfoProps = {
  label: string;
  value: string | null | undefined;
};

function CampoInfo({ label, value }: CampoInfoProps) {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={500}>
        {value || '-'}
      </Typography>
    </Grid>
  );
}

export default function InfoTicket({ ticket }: InfoTicketProps) {
  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main', mb: 1 }}
      >
        <InfoIcon fontSize="small" />
        Informacion del Ticket
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <CampoInfo
          label="Tipo"
          value={ticket.tipo_data?.nombre}
        />
        <CampoInfo
          label="Categoria"
          value={ticket.categoria_data?.nombre}
        />
        <CampoInfo
          label="Subcategoria"
          value={ticket.subcategoria_data?.nombre}
        />
        <CampoInfo
          label="Canal"
          value={ticket.canal_data?.nombre}
        />
        <CampoInfo
          label="Area Origen"
          value={ticket.area_origen_data?.nombre}
        />
        <CampoInfo
          label="Area Destino"
          value={ticket.area_destino_data?.nombre}
        />
        <CampoInfo
          label="Creado por"
          value={ticket.usuario_creador_nombre}
        />
        <CampoInfo
          label="Asignado a"
          value={ticket.usuario_asignado_nombre || 'Sin asignar'}
        />
        <CampoInfo
          label="Fecha de Creacion"
          value={dayjs(ticket.fecha_creacion).format('DD/MM/YYYY HH:mm')}
        />
        <CampoInfo
          label="Ultima Modificacion"
          value={dayjs(ticket.fecha_modificacion).format('DD/MM/YYYY HH:mm')}
        />
      </Grid>

      <Divider sx={{ my: 2 }} />

      <Typography variant="caption" color="text.secondary">
        Descripcion
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5, whiteSpace: 'pre-wrap' }}>
        {ticket.descripcion || '-'}
      </Typography>
    </Paper>
  );
}
